import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";

/**
 * 完了ダイアログHook
 * 処理が完了した時のダイアログを表示する
 */
export function useSuccessDialog() {
    
    const [isSuccess, setIsSuccess] = useState(false);

    function openDialog() {
        setIsSuccess(true);
    }

    function SuccessDialog() {
        return(
            <>
                <Dialog
                    open={isSuccess}
                    onClose={() => setIsSuccess(false)}
                >
                    <DialogTitle>
                        完了
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            処理が正常に完了しました。
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </>
        );
    }

    return {
        /**
         * 実行すると完了ダイアログが表示される
         */
        openSuccessDialog: openDialog,

        /**
         * ダイアログを表示する画面要素のどこかに配置する
         */
        SuccessDialog: SuccessDialog,
    }

}